// Gender options (mp_gender). Value is the stored code; text is the Thai label shown in the UI.
export const genderList = () => [
  { text: "ชาย", value: "m" },
  { text: "หญิง", value: "f" },
];

// Resolve a stored code to its Thai label (falls back to "-").
export const genderText = (value) => {
  const found = genderList().find(
    (option) => option.value === (value || "").toLowerCase()
  );
  return found ? found.text : "-";
};
